import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLevelUpAlt, faSatelliteDish, faSitemap, faSync, faTag, faTags, faToggleOff, faToggleOn, faUnlink} from '@fortawesome/free-solid-svg-icons';

export const ICONS = {
    CONNECTED: faSatelliteDish,
    CONNECTING: faSync,
    DISCONNECTED: faUnlink,
    LEVEL_UP: faLevelUpAlt,
    NODE: faSitemap,
    PROPERTY: faTag,
    PROPERTIES: faTags,
    TOGGLE_OFF: faToggleOff,
    TOGGLE_ON: faToggleOn,
};

const Icon = ({icon, ...rest}) => <FontAwesomeIcon icon={icon} {...rest} />;

export default Icon;
